import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { ToastrService } from 'ngx-toastr';
import {
  DateHelperUtil,
  NgbDateRange,
} from '../../utils/date-helper/date-helper.util';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  standalone: false,
})
export class DateRangePickerComponent {
  @Output() dateRangeChanged = new EventEmitter<NgbDateRange>();
  @Input() required = false;
  @Input() id: string = UUID.UUID();
  @Input() currentDateIsMinDate = false;
  @Input() minimumNumberOfDaysFromTodayInToDate = 0;
  @Input() maximumNumberOfDaysFromTodayInToDate: number = undefined;
  @Input() flexDirectionClass = 'flex-column flex-sm-row';
  currentDate = DateHelperUtil.getCurrentNgbDate();
  fromDate: NgbDate;
  toDate: NgbDate;

  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService,
  ) {}

  getMinToDate(): undefined | NgbDate {
    const fromDate = this.fromDate || this.getMinFromDate();
    return this.minimumNumberOfDaysFromTodayInToDate &&
      fromDate &&
      DateHelperUtil.areDatesEqual(fromDate, this.currentDate)
      ? DateHelperUtil.addDaysToNgbDate(
          fromDate,
          this.minimumNumberOfDaysFromTodayInToDate,
        )
      : fromDate;
  }

  getMaxToDate(): undefined | NgbDate {
    return this.maximumNumberOfDaysFromTodayInToDate !== undefined &&
      this.fromDate
      ? DateHelperUtil.addDaysToNgbDate(
          this.fromDate,
          this.maximumNumberOfDaysFromTodayInToDate,
        )
      : undefined;
  }

  getMinFromDate(): undefined | NgbDate {
    return this.currentDateIsMinDate ? this.currentDate : undefined;
  }

  setPeriod(period: NgbDateRange): void {
    this.fromDate = period.from;
    this.toDate = period.to;

    this.handleDateChanged();
  }

  resetPeriod(): void {
    this.fromDate = undefined;
    this.toDate = undefined;

    this.handleDateChanged();
  }

  handleDateChanged(): void {
    const maxToDate = this.getMaxToDate();
    if (
      maxToDate &&
      DateHelperUtil.compareTwoDates(this.toDate, maxToDate) > 0
    ) {
      this.showExtendedDateRangeWarn();
      this.toDate = maxToDate;
    }
    this.dateRangeChanged.emit(new NgbDateRange(this.fromDate, this.toDate));
  }

  showExtendedDateRangeWarn(): void {
    this.translateService
      .get(
        this.maximumNumberOfDaysFromTodayInToDate === 1
          ? 'DATE_RANGE_PICKER.MAX_PERIOD_INFO_ONE_DAY'
          : 'DATE_RANGE_PICKER.MAX_PERIOD_INFO',
        {
          days: this.maximumNumberOfDaysFromTodayInToDate,
        },
      )
      .subscribe((text) => this.toastr.warning(text));
  }
}
